import React from "react";
import Navbar from "./Navbar";
import "./Layout.css";
// Media & social
import footer_vid1 from "./animations/Footer_Vid1.mp4";
import linkedin from "../images/linkedin.png";
import facebook from "../images/facebook.png";
import insta from "../images/insta.png";

const Layout = ({ children }) => {
  return (
  <div className="layout-root">
    {/* ===== NAVBAR (sticky, translucent) ===== */}
    <header className="nav-shell">
    <div className="nav-inner">
    <Navbar />
    </div>
    </header>
    {/* Title spacer (optional) */}
    <div className="navbar-title">
    <h1></h1>
    </div>
    {/* ===== PAGE CONTENT ===== */}
    <main className="page-content">{children}</main>
    {/* ===== FOOTER ===== */}
    <footer className="site-footer">
      <div className="footer-inner">

        <div className="footer-top">
          <h2>Empowering healthcare providers with efficient, scalable solutions.</h2>

          <div className="footer-contact">
            <h3>How can we assist you?</h3>
            <p>
              We value the opportunity to connect with you. Please submit your inquiry and our team will follow up.
            </p>
            <a className="footer-cta" href="/form-page">
              Contact Us <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>

        <div className="footer-links">
          <nav className="footer-section">
            <h3>Company</h3>
            <ul>
              <li><a href="/about-us">About Us</a></li>
              <li><a href="/interest/careers">Careers</a></li>
              <li><a href="/form-page">Contact Us</a></li>
              <li><a href="/locations">Locations</a></li>
              <li><a href="/leaders">Leadership</a></li>
              <li><a href="/costs-and-certification">Costs and Certification</a></li>
            </ul>
          </nav>

          <nav className="footer-section">
            <h3>Follow</h3>
            <ul>
              <li>
                <a href="https://www.linkedin.com/company/ss-healthcare-consulting/"
                  target="_blank" rel="noopener noreferrer" className="social-link">
                  <img src={linkedin} alt="LinkedIn" className="social-icon" />
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/sshealthcareconsulting/"
                  target="_blank" rel="noopener noreferrer" className="social-link">
                  <img src={facebook} alt="Facebook" className="social-icon" />
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/sshealthcareconsulting/"
                  target="_blank" rel="noopener noreferrer" className="social-link">
                  <img src={insta} alt="Instagram" className="social-icon" />
                  Instagram
                </a>
              </li>
            </ul>
          </nav>

          <nav className="footer-section">
            <h3>Legal</h3>
            <ul>
              <li><a href="/privacy-statement">Privacy Statement</a></li>
              <li><a href="/terms-conditions">Terms & Conditions</a></li>
              <li><a href="/cookie-policy">Cookie Policy / Settings</a></li>
              <li><a href="/accessibility-statement">Accessibility Statement</a></li>
              <li><a href="/sell-share-info">Do Not Sell/Share My Personal Information</a></li>
            </ul>
          </nav>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            © {new Date().getFullYear()} S&S Healthcare Consultancy. All Rights Reserved.
          </p>
        </div>

      </div>
    </footer>



  </div>
  );
};
export default Layout;
